export const ADD_CREDENTIALS = "ADD_CREDENTIALS";
export const SET_AUTH_STATUS = "SET_AUTH_STATUS";
export const DO_LOGOUT = "DO_LOGOUT";


// WEBPACK FOOTER //
// ./src/store/actions/constants.js